import TableCardv2 from "../../components/TableCardv2";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { debounce } from "lodash";
import styles from "./styles.module.css";
import { useContext, useEffect, useState, useRef } from "react";
import { buscarProjetos } from "../../services/api-planejamento-tributario.service";
import Loading from "../../components/Loading";
import { formatValue } from "../../utils/formatValue";
import { PreviaInssContext } from "../PreviaINSS/PreviaInssContext";
import ModalVersoesProjeto from "../../components/Projeto/ModalVersoesProjeto";
import { usePreviaPisCofins } from "../PreviaPISCOFINS/PreviaPisCofinsContext";
import { usePermissoes, CHAVES_PIS_COFINS_VIEW } from "../../config/Context/PermissoesContext";

const ProjetosPISCOFINS = () => {
  const { pode, carregado, chaves } = usePermissoes();
  const handleOrganizaDataRef = useRef((x) => x);
  const [projetos, setProjetos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVersoes, setModalVersoes] = useState({
    open: false,
    idProjeto: null,
  });
  const [modalAnalisar, setModalAnalisar] = useState({});

  const { buscaDadosPrevia } = useContext(PreviaInssContext);
  const header = {
    icon: <CurrencyExchangeIcon />,
    title: "Projetos PIS/COFINS",
  };
  const functionDebounce = debounce((value) => handleDebounce(value), 1000);
  const columns = [
    { key: "razaoSocial", label: "Razão Social" },
    { key: "cnpj", label: "CNPJ" },
    { key: "categoria", label: "Categoria" },
    { key: "dtInicial", label: "Data Inicial" },
    { key: "dtFinal", label: "Data Final" },
    { key: "status", label: "Status" },
  ];

  const handleRechargeData = async () => {
    setLoading(true);
    try {
      const response = await buscarProjetos("piscofins");
      setProjetos(handleOrganizaDataRef.current(response.projetos));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleOrganizaData = (data) => {
    const btnAnalisar = (row) => {
      if (!pode(CHAVES_PIS_COFINS_VIEW)) return null;
      return {
        icon: <QueryStatsIcon />,
        title: "Analisar",
        onClick: () => handleModalAnalisar(row),
      };
    };
    const btnVizualizar = (row) => ({
      icon: <VisibilityIcon />,
      title: "Visualizar",
      onClick: () => handleClick(row),
    });

    const formatStatus = (status) => {
      switch (status) {
        case "PROJETO-PENDENTE":
          return (
            <span className={styles.status_container}>
              <span className={styles.andamento} /> Andamento
            </span>
          );
        case "PROJETO-ENVIADO":
          return (
            <span className={styles.status_container}>
              <span className={styles.enviada} /> Enviado
            </span>
          );
        case "PROJETO-APROVADO":
          return (
            <span className={styles.status_container}>
              <span className={styles.aprovada} /> Aprovado
            </span>
          );
        case "PROJETO-CANCELADO":
          return (
            <span className={styles.status_container}>
              <span className={styles.cancelada} /> Cancelado
            </span>
          );
        default:
          break;
      }
    };

    return data.map((item) => {
      const formatBtn = (status) => {
        switch (status) {
          case "PROJETO-PENDENTE":
            return [btnAnalisar(item)].filter(Boolean);
          default:
            return pode(CHAVES_PIS_COFINS_VIEW) ? [btnVizualizar(item)] : [];
        }
      };
      return {
        razaoSocial: item.razaoSocial,
        cnpj: formatValue("cnpj", item.cnpj),
        categoria: item.categoriaTributaria?.descricao || "Sem categoria",
        dtInicial: formatValue("data", item.dtInicial),
        dtFinal: formatValue("data", item.dtFinal),
        status: formatStatus(item.status),
        btn: formatBtn(item.status),
      };
    });
  };

  handleOrganizaDataRef.current = handleOrganizaData;

  useEffect(() => {
    if (!carregado) return;
    handleRechargeData();
  }, [carregado, chaves]);

  const handleModalAnalisar = async (data) => {
    sessionStorage.setItem("cnpjSelecionado", data.cnpj);
    setModalVersoes({ open: true, idProjeto: data.idProjeto });
    setModalAnalisar(data);
  };

  const handleClick = (row) => {
    if (!row?.idProjeto) return;
    sessionStorage.setItem("cnpjSelecionado", row.cnpj);
    setModalVersoes({ open: true, idProjeto: row.idProjeto });
    setModalAnalisar(row);
  };

  const handleDebounce = (value) => {};

  return (
    <div className={styles.container}>
      {loading ? (
        <Loading loading={loading} />
      ) : (
        <TableCardv2
          columns={columns}
          data={projetos}
          header={header}
          debounce={functionDebounce}
          loading={loading}
        />
      )}
      <ModalVersoesProjeto
        open={modalVersoes.open}
        onClose={() => setModalVersoes({ open: false, idProjeto: null })}
        idProjeto={modalVersoes.idProjeto}
        tipoProjeto="PIS-COFINS"
        contextHook={usePreviaPisCofins}
        dadosEmpresa={modalAnalisar}
      />
    </div>
  );
};

export default ProjetosPISCOFINS;
